import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import './CompleteBody.css';
import { format } from 'date-fns';

export default function PendingBody() {
    const location = useLocation();
    const navigate = useNavigate();
    const { date } = location.state;
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const ordersPerPage = 25;

    useEffect(() => {
        if (!date) {
            console.error('Date not provided');
            return;
        }

        // Directly use date as it is in YYYY-MM-DD format
        const formattedDate = date;

      

        axios.get(`${process.env.REACT_APP_API_URL}/pendingOrder/${formattedDate}`)
            .then(response => {
            
                const ordersData = response.data;
                setOrders(ordersData);
                setFilteredOrders(ordersData);
            })
            .catch(error => {
                console.error('Error fetching orders:', error);
            });
    }, [date]);

    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);
    const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleSearch = () => {
        const filtered = orders.filter(order => order.CustomerPhone.includes(searchTerm));
        setFilteredOrders(filtered);
        setCurrentPage(1); // Reset to first page after search
    };

    const handleRefresh = () => {
        setFilteredOrders(orders);
        setSearchTerm('');
        setCurrentPage(1); // Reset to first page after refresh
    };

    const formatOrderDate = (dateStr) => {
        const dateObj = new Date(dateStr);
        return isNaN(dateObj.getTime()) ? 'Invalid Date' : format(dateObj, 'yyyy-MM-dd');
    };

    const handleRowClick = (order) => {
        navigate('/billPage', {
            state: {
                orderDate: order.OrderDate,
                customerPhone: order.CustomerPhone
            }
        });
    };

    return (
        <div className="container">
            {/* Search and Refresh Section */}
            <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                <input 
                    type="text" 
                    placeholder="Search by customer phone number..." 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ padding: "10px", flex: "1", marginRight: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                />
                <button 
                    onClick={handleSearch} 
                    style={{ padding: "10px 20px", marginRight: "10px", borderRadius: "5px", backgroundColor: "#009879", color: "white", border: "none", cursor: "pointer" }}
                >
                    Search
                </button>
                <button 
                    onClick={handleRefresh} 
                    style={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#ccc", color: "black", border: "none", cursor: "pointer" }}
                >
                    Refresh
                </button>
            </div>

            <table className="styled-table">
                <thead>
                    <tr>
                        <th>Customer Name</th>
                        <th>Customer Phone</th>
                        <th>Customer Address</th>
                        <th>Customer Pin</th>
                        <th>Order Date</th>
                    </tr>
                </thead>
                <tbody>
    {currentOrders.map(order => (
        <tr key={order.CustomerPhone} onClick={() => handleRowClick(order)} style={{ cursor: 'pointer' }}>
            <td>{order.CustomerName}</td>
            <td>{order.CustomerPhone}</td>
            <td>{order.CustomerAddress}</td>
            <td>{order.CustomerPin}</td>
            <td>{formatOrderDate(order.OrderDate)}</td>
        </tr>
    ))}
</tbody>

            </table>

            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    &laquo;
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                    <button
                        key={i + 1}
                        onClick={() => paginate(i + 1)}
                        className={i + 1 === currentPage ? 'active' : ''}
                    >
                        {i + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    &raquo;
                </button>
            </div>
        </div>
    );
}
